/* eslint-disable radix */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import track from 'react-tracking';
import {
  ChatInput,
  ButtonList,
  ChatSlideInput,
  AgePicker,
} from 'components';
import { LayoutChat } from 'layouts';
import { COMPONENT_TYPE, PATH } from 'shared/constants';
import { getRTL } from 'shared/redux/selectors';
import {
  submitReply, clearConversationHistory, updateSummary, updateStep,
} from 'shared/redux/actions';
import { injectIntl } from 'react-intl';
import iconBigpurchase from 'assets/icons/iconBigpurchase.png';
import iconEducation from 'assets/icons/iconEducation.png';
import iconIncome from 'assets/icons/iconIncome.png';
import iconInvestment from 'assets/icons/iconInvestment.png';
import iconLegacy from 'assets/icons/iconLegacy.png';
import iconRetirement from 'assets/icons/iconRetirement.png';
import iconClose from 'assets/icons/iconTopbarClose.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';

import {
  trackFinancialGoal, trackAge, trackingUserName, trackInvestableAsset,
} from './InvestorProfile.tracking';
import trackEvent from 'components/TrackEvent';
import { 
  eventInvestmentProfileAge, 
  eventInvestmentProfileGoal, 
  eventInvestmentProfileInitialCapital, 
  eventInvestmentProfileName, 
  eventInvestmentProfileTargetAmount,
  eventInvestmentProfileGoalYears,
  eventInvestmentProfileAnnualContribution,
 } from 'components/TrackEvent/constEvent';

class InvestorProfile extends Component {
  processButtonIconList = (inputOptions) => {
    const returnIcon = (payload) => {
      switch (payload) {
        case 'education':
          return iconEducation;
        case 'retirement':
          return iconRetirement;
        case 'investment':
          return iconInvestment;
        case 'big_purchase':
          return iconBigpurchase;
        case 'legacy':
          return iconLegacy;
        case 'income':
          return iconIncome;
        default:
          return null;
      }
    };
    return inputOptions.map(item => ({
      text: item.text,
      icon: returnIcon(item.payload),
      iconActive: returnIcon(item.payload),
      payload: item.payload,
    }));
  };

   closeInvestorProfile = () => {
     const {
       history,
       //  onReplySubmit,
     } = this.props;
     //  onReplySubmit('quit');
     history.push(PATH.JOURNEY_OVERVIEW);
   };

    handleRestart = () => {
      const { onClearConversationHistory, onReplySubmit } = this.props;
      onClearConversationHistory().then(() => onReplySubmit('restart'));
    };

    render() {
      const {
        conversations,
        inputComponent,
        inputOptions,
        onReplySubmit,
        rtl,
        onUpdateSummary,
        intl,
        messageOptions,
        tracking,
        currentLocale,
        summary
      } = this.props;

      let input;

      switch (inputComponent) {
        case COMPONENT_TYPE.NAME_INPUT:
          input = (
            <ChatInput
              rtl={rtl}
              placeholder="input.EnterYourNameText"
              onSubmit={(reply) => {
                onReplySubmit(reply, { toTranslate: false });
                onUpdateSummary({ 'summary.name': reply });
                /** track user name */
                trackingUserName(tracking, reply);
                trackEvent(eventInvestmentProfileName(currentLocale, reply));
                /** */
              }}
            />
          );
          break;
        case COMPONENT_TYPE.AGE_PICKER:
          input = (
            <AgePicker
              rtl={rtl}
              defaultValue={35}
              onSubmit={(reply) => {
                onReplySubmit(reply, {
                  suffix: 'years',
                  toTranslate: false,
                });
                onUpdateSummary({ 'summary.age': `${reply}` });
                /** Track financial goal */
                trackAge(tracking, reply);
                trackEvent(eventInvestmentProfileAge(currentLocale, summary ? summary['summary.name'] : '', reply));
                /** */
              }}
            />
          );
          break;
        case COMPONENT_TYPE.ESTIMATE_WEALTH:
          input = (
            <ButtonList
              optionList={inputOptions}
              onOptionClick={(reply) => {
                onReplySubmit(reply);
                onUpdateSummary({ 'summary.investableAsset': reply });
                /** track estimate wealth */
                trackInvestableAsset(tracking, reply);
                /** */
              }}
              isOptionButton
              rtl={rtl}
            />
          );
          break;
        case COMPONENT_TYPE.FINANCIAL_GOAL:
          input = (
            <ButtonList
              buttonWithIconList={this.processButtonIconList(inputOptions)}
              onButtonClick={(reply, option) => {
                onReplySubmit(reply, option);
                onUpdateSummary({ 'summary.goal': reply });
                /** Track financial goal */
                trackFinancialGoal(tracking, reply);
                trackEvent(eventInvestmentProfileGoal(currentLocale, summary['summary.name'], summary['summary.age'], reply));
                /** */
              }}
              isButtonWithIcon
              rtl={rtl}
            />
          );
          break;
        case COMPONENT_TYPE.YEAR_ACHIEVE:
          input = (
            <ChatSlideInput
              rtl={rtl}
              onSubmit={(reply) => {
                onReplySubmit(reply, {
                  suffix: parseInt(reply) === 1 ? 'year' : 'years',
                  toTranslate: false,
                });
                onUpdateSummary({ 'summary.targetCompletion': `${reply}` });
                trackEvent(eventInvestmentProfileGoalYears(
                  currentLocale, 
                  summary['summary.name'], 
                  summary['summary.age'], 
                  summary['summary.goal'], 
                  summary['summary.targetAmount'], 
                  reply
                ));
              }}
              max={inputOptions && inputOptions[0][inputOptions[0].goal]}
            />
          );
          break;
        case COMPONENT_TYPE.TARGET_AMOUNT:
          input = (
            <ChatInput
              rtl={rtl}
              placeholder="input.EnterInKWD"
              onSubmit={(reply) => {
                onReplySubmit(reply, { prefix: 'KWD', toTranslate: false });
                onUpdateSummary({ 'summary.targetAmount': `KWD ${reply}` });
                trackEvent(eventInvestmentProfileTargetAmount(
                  currentLocale, 
                  summary['summary.name'], 
                  summary['summary.age'], 
                  summary['summary.goal'], 
                  reply
                ));
              }}
              min={inputOptions && inputOptions[0][messageOptions.text]}
              hookValue={messageOptions.target_amount}
              isCurrency
            />
          );
          break;
        case COMPONENT_TYPE.INITIAL_CAPITAL:
          input = (
            <ChatInput
              rtl={rtl}
              placeholder="input.EnterInKWD"
              onSubmit={(reply) => {
                onReplySubmit(reply, { prefix: 'KWD', toTranslate: false });
                onUpdateSummary({ 'summary.initialInvestment': `KWD ${reply}` });
                trackEvent(eventInvestmentProfileInitialCapital(
                  currentLocale,
                  summary['summary.name'],
                  summary['summary.age'],
                  reply
                ));
              }}
              hookValue={messageOptions.initial_capital}
              isCurrency
            />
          );
          break;
        case COMPONENT_TYPE.ANNUAL_CONTRIBUTION:
          input = (
            <ChatInput
              rtl={rtl}
              placeholder="input.EnterInKWD"
              type="tel"
              onSubmit={(reply) => {
                onReplySubmit(reply, { prefix: 'KWD', toTranslate: false });
                onUpdateSummary({ 'summary.annualInvestment': `KWD ${reply}` });
                trackEvent(eventInvestmentProfileAnnualContribution(
                  currentLocale,
                  summary['summary.name'],
                  summary['summary.age'],
                  summary['summary.goal'], 
                  summary['summary.targetAmount'], 
                  summary['summary.targetCompletion'],
                  summary['summary.initialInvestment'],
                  reply
                ));
              }}
              hookValue={messageOptions.annual_contribution}
              isCurrency
            />
          );
          break;
        default:
          input = '';
      }

      return (
        <LayoutChat
          conversations={conversations}
          input={input}
          navTitle="investor.yourInvestorProfile"
          subTitle={intl.formatMessage({ id: 'journey.step' }, { number: 1 })}
          leftButton={<FontAwesomeIcon icon={faRedo} />}
          onLeftClick={this.handleRestart}
          rightButton={<img src={iconClose} alt="X" />}
          onRightClick={this.closeInvestorProfile}
          {...this.props}
        />
      );
    }
}

const mapStateToProps = ({ rootReducer }) => ({
  conversations: rootReducer.investorConversations,
  inputComponent: rootReducer.inputComponent,
  inputOptions: rootReducer.inputOptions,
  messageOptions: rootReducer.messageOptions,
  rtl: getRTL(rootReducer),
  currentLocale: rootReducer.language.locale,
  // username: rootReducer.vars ? rootReducer.vars.name : null
  summary: rootReducer.summary
});

const mapDispatchToProps = ({
  onReplySubmit: submitReply,
  onClearConversationHistory: clearConversationHistory,
  onUpdateSummary: updateSummary,
  onUpdateStep: updateStep,
});

export default track({
  page: 'InvestorProfile',
})(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(InvestorProfile)));
